import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
// import LandingPage from 'containers/LandingPage/Loadable';
import Budapest2025 from 'containers/2025budapest/Loadable';
import CookieDeclaration from 'containers/CookieDeclaration';

class App extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }
  render() {
    return (
      <main className="app">
        <Switch>
          <Route exact path="/" component={Budapest2025} />
          <Route exact path="/2025budapest" component={Budapest2025} />
          <Route exact path="/cookie-declaration" component={CookieDeclaration} />
          <Redirect to="/not-found" />
        </Switch>
      </main>
    );
  }
}

App.propTypes = {
  location: PropTypes.object.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/index.js